import { createContext, useContext } from "react";

export const ContextAgentContext = createContext(null);

const noop = () => {};

const fallback = {
  registration: null,
  handlersRef: { current: { panel: null, onOpenChange: null, onToggleClick: null } },
  panelGeneration: 0,
  open: false,
  setOpen: noop,
  toggleOpen: noop,
  setRegistration: noop,
  clearRegistration: noop,
  syncHandlers: noop,
  isRegistered: false,
};

export function useContextAgent() {
  const ctx = useContext(ContextAgentContext);
  return ctx ?? fallback;
}
